module.exports = __webpack_public_path__ + "static/media/banner-euro-2024.1e7a28e1.webp";